/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

const prefix = 'assistant/session';

export const CREATE_SESSION = `${prefix}/create-session`;
export const DESTROY_SESSION = `${prefix}/destroy-session`;
export const RESET_SESSION = `${prefix}/reset-session`;
export const SET_TENANT = `${prefix}/set-tenant`;
export const SET_WORKSPACE = `${prefix}/set-workspace`;
export const SET_WORKSPACE_DETAIL = `${prefix}/set-workspace-detail`;
export const SET_USER = `${prefix}/set-user`;
export const SET_ACCOUNT = `${prefix}/set-account`;
export const SET_SKILL_ID = `${prefix}/set-skill-id`;
export const SET_ASSISTANT_ID = `${prefix}/set-assistant-id`;
export const SET_INSTANCE_STATE = `${prefix}/set-instance-state`;
export const SET_READ_ONLY = `${prefix}/session/set-read-only`;

export const FETCH_USER_START = `${prefix}/fetch-user-start`;
export const FETCH_USER_SUCCESS = `${prefix}/fetch-user-success`;
export const FETCH_USER_ERROR = `${prefix}/fetch-user-error`;

export const SESSION_INACTIVE = `${prefix}/session-inactive`;
export const SESSION_REVOKED = `${prefix}/session-revoked`;
export const IP_ADDRESS_RESTRICTION = `${prefix}/ip-address-restriction`;
